import { render, staticRenderFns } from "./ImageGallery.vue?vue&type=template&id=46c0bad4&"
import script from "./ImageGallery.vue?vue&type=script&lang=js&"
export * from "./ImageGallery.vue?vue&type=script&lang=js&"
import style0 from "./ImageGallery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports